import { MarketType } from '../enums/market-type.enum'

export interface ILaborsReportItem {
  invoicedLabor: number
  laborHour: number
  effectiveLaborRate: number
  laborPerVehicle: number
  vehiclesInvoiced: number
  invoicedLaborFormatted: string
  laborHourFormatted: string
  effectiveLaborRateFormatted: string
  laborPerVehicleFormatted: string
}

export interface ILaborsReportData extends ILaborsReportItem {
  day: string
}

export interface ILaborsReportSummary {
  summary: ILaborsReportItem
  laborData: ILaborsReportData[]
  id: string
  countryId: string
  displayText: string
  marketType: MarketType
  noData: boolean
}

export interface ILaborsReportTableItem extends ILaborsReportItem {
  id: string
  countryId: string
  displayText: string
  marketType: MarketType
  noData: boolean
}

export interface ILaborsReportResponse {
  laborSummaries: ILaborsReportSummary[]
  intervalLabel: string
}
